<div
	id="plp-srlp-compare-bar"
	class="plp-srlp-compare-bar hmf-display-flex hmf-justify-content-between hmf-px-s hmf-px-l-m hmf-py-xs hmf-span-12">

	<p class="compare-selected-count hmf-align-self-center hmf-body-l hmf-my-0">{{ compareList.length }} <span class="hmf-display-none hmf-display-lg-inline">Product{{ compareList.length === 1 ? ' ' : 's ' }}</span>Selected</p>

	<div
		class="compare-actions-container hmf-display-flex hmf-justify-content-flex-end"
	>
		@for (compareProduct of compareList; track trackByFn($index, compareProduct)) {
			<plp-components-compare-thumbnail
				class="hmf-display-none hmf-display-lg-block hmf-px-xxs"
				[compareData]="compareProduct"
				(remove)="removeFromCompareList($event)"
			></plp-components-compare-thumbnail>
		}
		<button hmf-button
			class="compare-action-button-clear hmf-align-self-center hmf-mr-xxxs hmf-p-0 hmf-ml-s hmf-label-s hmf-label-lg-l"
			[variant]="'secondary'"
			(click)="clearAllCompareList()"
		>
			Clear All
		</button>
		<button hmf-button
			class="compare-action-button-compare hmf-align-self-center hmf-mx-xxxs hmf-label-s hmf-label-lg-l"
			[variant]="'primary'"
			[disabled]="compareList.length < 2"
			[label]="'Compare'"
			(click)="compareProducts()"
		>
			Compare
		</button>
	</div>
</div>